"use client";
import React, { useState, useEffect } from "react"

import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import "./stylesSlider.css"

import { useGetYoutubeVideoQuery } from "@/store";

import youtubeLinks from './constant';

function SliderForYoutube() {

    const { data } = useGetYoutubeVideoQuery();

    const getEmbedUrl = (url) => {
        const videoId = url.split('v=')[1].split('&')[0];
        return `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&rel=0&autoplay=0&showinfo=0&controls=1`;
    };

    const [currentSlide, setCurrentSlide] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        loop: true,
        breakpoints: {
            "(min-width: 980px)": {
                slides: { perView: 2, spacing: 0 },
            },
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel)
        },
        created() {
            setLoaded(true)
        },
    })

    if (!data || data.body.length < 1) {
        return null;
    }
    
    return (
                <div className="bg-white">
                    <div className="SocialMediaSlider relative mt-8">
                        <div ref={sliderRef} className="keen-slider">
                            {data?.body?.map((item, index) => (
                                <div className="keen-slider__slide  px-8" key={index}>
                                    <iframe
                                        width="560"
                                        height="400"
                                        src={getEmbedUrl(item.youtube_url)}
                                        title={`YouTube video player`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; modestbranding; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        sandbox="allow-forms allow-scripts allow-presentation allow-pointer-lock allow-same-origin allow-top-navigation"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            ))}
                        </div>
                        {loaded && instanceRef.current && (
                            <>
                                <Arrow left onClick={(e) =>  e.stopPropagation() || instanceRef?.current?.prev() } />

                                <Arrow onClick={(e) => e.stopPropagation() || instanceRef?.current?.next() } />
                            </>
                        )}
                    </div>
                    {loaded &&   (
                        <div className="flex justify-center pt-4">
                            {[ ...Array(data?.body?.length).keys(),
                            ].map((idx) => {
                                return (
                                    <button
                                        key={idx}
                                        onClick={() => {
                                            instanceRef.current?.moveToIdx(idx)
                                        }}
                                        className={"dot" + (currentSlide === idx ? " active" : "")}
                                    ></button>
                                )
                            })}
                        </div>
                    )}
                </div>
    );
}

export default SliderForYoutube;


function Arrow(props) {
    const disabled = props.disabled ? " arrow--disabled cursor-none" : ""
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${props.left ? "arrow--left" : "arrow--right"
                } ${disabled}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            {props.left && (
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            )}
            {!props.left && (
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
            )}
        </svg>
    )
}
